









































import { computed, defineComponent, PropType } from '@vue/composition-api'
import HUDPage from './HUDPage.vue'
import DotLoader from '@f/components/DotLoader.vue'
import useRoutes from '@f/composables/useRoutes'
import { TrUserCountrySummary } from '@f/@types/graphql'
import { maxWidth, useMediaQuery } from '@f/utils/breakpoints'
import useUserInfo from '@f/composables/useUserInfo'
import { DataEventMap } from '@f/services/TagManager/events';

// @ts-ignore
export default defineComponent({
  name: 'HUDUserCountries',
  components: {
    HUDPage,
    DotLoader,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    countrySummaries: {
      type: Array as PropType<TrUserCountrySummary[]>,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const { href } = useRoutes()
    const isMobile = useMediaQuery(maxWidth('md'))
    const { userInfo: loggedUserInfo } = useUserInfo()
    const ecommerceUrl = computed(() => {
      if (loggedUserInfo.value?.usertype === 'Business') {
        return href('species')
      }
      return href('user.map.plant')
    })

    const onCountrySelect = (country: string) => {
      DataEventMap({ countrySelected: country  })
    }

    return {
      href,
      isMobile,
      ecommerceUrl,
      onCountrySelect
    }
  }
})
